'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _components2 = require('components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SlideView: {
        displayName: 'SlideView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Slide/default/SlideView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var SlideView = _wrapComponent('SlideView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(SlideView, _Component);

    function SlideView() {
        (0, _classCallCheck3.default)(this, SlideView);
        return (0, _possibleConstructorReturn3.default)(this, (SlideView.__proto__ || (0, _getPrototypeOf2.default)(SlideView)).apply(this, arguments));
    }

    (0, _createClass3.default)(SlideView, [{
        key: 'render',
        value: function render() {
            var sliderComp = _react3.default.createElement(_components2.SliderWithQR, {
                items: this.props.slidesList,
                autoplay: true,
                autoplaySpeed: 10000,
                updateProducts: this.props.updateProducts
            });

            if (this.props.slidesList.length !== 0) {
                return _react3.default.createElement(
                    'div',
                    { className: 'Slide__view u-full-height' },
                    sliderComp
                );
            }

            return null;
        }
    }]);
    return SlideView;
}(_react2.Component), _class.propTypes = {
    slidesList: _propTypes2.default.array,
    updateProducts: _propTypes2.default.func
}, _class.defaultProps = {
    slidesList: []
}, _temp));

exports.default = SlideView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Slide/default/SlideView.jsx
// module id = 1849
// module chunks = 0